import React from 'react';

const Panel = ({ as: Component = 'section', className = '', children, ...props }) => (
  <Component className={`content-panel ${className}`.trim()} {...props}>
    {children}
  </Component>
);

export default Panel;
